import Parametros from 'Interface/Requisicao';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function formData(dados: any, metodo: 'POST' | 'PUT' | 'DELETE'): FormData
{
    const formData: FormData = new FormData();

    formData.append('_method', metodo);

    Object.keys(dados).forEach(chave => {
        if (typeof dados[chave] == 'object' && dados[chave] && dados[chave]['_ids']) {
            dados[chave]['_ids'].map((id: string, i: number) => {
                formData.append(`${chave}[_ids][${i}]`, id);
            });
        } else {
            formData.append(chave, dados[chave]);
        }
    });

    return formData;
}

export function paramsParaString(params: Parametros | object | void, prefix = ''): string
{
    const str = [];

    if (params) {
        for (const param in params) {
          // eslint-disable-next-line no-prototype-builtins
          if (params.hasOwnProperty(param)) {
            const k = prefix ? prefix + '[' + param + ']' : param;
            const v = params[param as keyof typeof params];

            str.push(
                (v !== null && typeof v === 'object')
                    ? paramsParaString(v, k)
                    : encodeURIComponent(k) + '=' + encodeURIComponent(v)
            );
          }
        }
    }

    return str.join('&');
}
